import React, { createContext } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import CardEmpty from "Utils/Cards/CardEmpty";
import { useCorrelativoTancadas } from "../../hooks/useCorrelativoTancadas";

// Estado del correlativo que ya consultó el bloqueo, para que las pantallas de
// adentro trabajen sobre la misma instancia: si una deshace el período, el
// bloqueo se entera y aparece sin tener que recargar
export const CorrelativoTancadasContext = createContext(null);

const RUTA_CONFIGURACION = "/produccion-v2/turnos-produccion";

const NOMBRE_PANTALLA = "Producción / Turnos de producción";

// Las pantallas del turno no se pueden usar mientras no exista el correlativo
// de tancadas, porque las tancadas que se registren quedarían sin número. Se
// configura en turnos de producción, que por eso queda fuera del bloqueo.
// Mientras responde el servidor se asume configurado, para no interrumpir el
// caso normal con un bloqueo que aparece y desaparece
const BloqueoCorrelativoTancadasBase = ({
    children,
    accesoConfiguracion,
    history,
}) => {
    const correlativo = useCorrelativoTancadas();

    if (correlativo.configurado) {
        return (
            <CorrelativoTancadasContext.Provider value={correlativo}>
                {children}
            </CorrelativoTancadasContext.Provider>
        );
    }

    return (
        <CardEmpty>
            <div className="text-center py-5">
                <h4 className="mb-3">
                    Falta configurar el correlativo de tancadas
                </h4>
                <p className="mb-0 text-sm">
                    Antes de trabajar el turno hay que indicar desde qué número
                    se numerarán las tancadas.<br /> Se configura en{" "}
                    {accesoConfiguracion ? (
                        <Link to={RUTA_CONFIGURACION}>{NOMBRE_PANTALLA}</Link>
                    ) : (
                        <b>{NOMBRE_PANTALLA}</b>
                    )}
                    .
                </p>

                <div className="d-flex justify-content-center mt-4 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={() => history.goBack()}
                    >
                        Regresar
                    </button>
                </div>
            </div>
        </CardEmpty>
    );
};

// El enlace solo se muestra a quien ya tiene acceso a turnos de producción,
// que es el mismo permiso con el que aparece esa opción en el menú; a los demás
// roles se les dice dónde se configura
const mapStateToProps = (state) => {
    const usuario = state.login ? state.login.me : null;

    const permisos = usuario && usuario.rol_usuario ? usuario.rol_usuario : {};

    return {
        accesoConfiguracion: Boolean(permisos.turnos_produccion),
    };
};

export const BloqueoCorrelativoTancadas = withRouter(
    connect(mapStateToProps)(BloqueoCorrelativoTancadasBase),
);

// Envuelve una pantalla para el router. El resultado se guarda por componente,
// porque devolver uno nuevo en cada render volvería a montar la pantalla
const pantallas = new Map();

export const conCorrelativoTancadas = (Pantalla) => {
    if (!pantallas.has(Pantalla)) {
        pantallas.set(Pantalla, (props) => (
            <BloqueoCorrelativoTancadas>
                <Pantalla {...props} />
            </BloqueoCorrelativoTancadas>
        ));
    }

    return pantallas.get(Pantalla);
};
